import { render, staticRenderFns } from "./StoresDisplay.vue?vue&type=template&id=15a2c6eb&"
import script from "./StoresDisplay.vue?vue&type=script&lang=js&"
export * from "./StoresDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports